import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

const EmbeddedRoutesWrapper = () => {
  // Hide UserPilot in embedded routes
  useEffect(() => {
    if (window.userpilotRC) {
      window.userpilotRC.hide();
    }
  }, []);

  return <Outlet />;
};

export default EmbeddedRoutesWrapper;
